import { SET_CONFIG, RESET_CONFIG } from '../actions/types';

const initialState = {
  homePageMessage: '',
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case SET_CONFIG:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CONFIG:
      return {
        ...state,
        homePageMessage: '',
      };
    default:
      return state;
  }
}

export default reducer;
